export enum DrawerOpeningState {
  OPEN = 'open',
  COMPACT = 'compact',
  TINY = 'tiny',
}
